export class GeoBoundary {

    constructor(modelSection, data = {}) {

        this.id = data.id ?? null;
        this.uid = data.uid ?? null;
        this.name = data.name ?? null;
        this.boundaryType = data.boundaryType ?? null;
        this.elevation = data.elevation ?? null;
        this.modelSection = modelSection ?? null;
        this.notes = data.notes ?? null;

    }

}
